"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chunkError_1 = require("./utils/chunkError");
(0, chunkError_1.installChunkErrorGlobalHandler)();
void import('./bootstrap.tsx');
